<template>
  <div id="public-layout">
    <Header/>
    <router-view></router-view>
    <Footer/>
    <button v-on:click="scrollToTop()" id="btn-to-top">
      <img src="./../../assets/images/icon/back-top.png" width="35">
    </button>
  </div>
</template>

<script>
import Header from './Header'
import Footer from './Footer'

export default {
  name: 'PublicLayout',
  components: {
    Header,
    Footer
  },
   created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      },
      handleScroll() {
        let mybutton = document.getElementById("btn-to-top");
        window.onscroll = function () {
          scrollFunction()
        };

        function scrollFunction() {
          if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            mybutton.style.display = "block";
          } else {
            mybutton.style.display = "none";
          }
        }
      }
    }
}
</script>

<style scoped>
#btn-to-top {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    border: none;
    outline: none;
    cursor: pointer;
    background-color: transparent;
}
</style>
